import { useState } from "react";
import { List, ListItem } from "@mui/material";
import {
  strengthColor,
  strengthIndicator,
  strengthChecker,
} from "@/utils/password-strength";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export const Password = ({
  value,
  onChange,
  error,
  helperText,
  textLabel,
  useHelper,
  disabled,
}) => {
  const [showPass, setShowPass] = useState(false);
  const [helper, setHelper] = useState(false);
  const { color } = strengthColor(strengthIndicator(value));
  const { letters, number, special, length } = strengthChecker(value);
  return (
    <>
      <TextField
        disabled={disabled}
        label={textLabel}
        placeholder="****************"
        type={showPass ? "text" : "password"}
        id="newPassword"
        name="newPassword"
        autoComplete="current-password"
        fullWidth
        variant="outlined"
        color={color}
        onFocus={() => setHelper(true)}
        onBlur={() => setHelper(false)}
        value={value}
        onChange={onChange}
        error={error}
        helperText={helperText}
        slotProps={{
          input: {
            startAdornment: !useHelper && (
              <VpnKeyOutlinedIcon
                sx={{ mr: 2, width: 24, height: 24 }}
                color="primary"
              />
            ),
            endAdornment: showPass ? (
              <VisibilityIcon
                sx={{ cursor: "pointer", fontSize: "1.2rem" }}
                color="primary"
                onClick={() => {
                  if (disabled) return;

                  setShowPass(false);
                }}
              />
            ) : (
              <VisibilityOffIcon
                sx={{ cursor: "pointer", fontSize: "1.2rem" }}
                color="primary"
                onClick={() => {
                  if (disabled) return;

                  setShowPass(true);
                }}
              />
            ),
          },
        }}
      />
      {helper && useHelper && (
        <FormHelperText>
          <List dense style={{ marginBottom: "-1rem" }}>
            Deve conter pelo menos:
            <ListItem>
              {length && (
                <CheckOutlinedIcon
                  color="success"
                  fontSize="small"
                  style={{ marginRight: "0.5rem" }}
                />
              )}
              6 Caracteres
            </ListItem>
            <ListItem>
              {number && (
                <CheckOutlinedIcon
                  color="success"
                  fontSize="small"
                  style={{ marginRight: "0.5rem" }}
                />
              )}
              Um número
            </ListItem>
            <ListItem>
              {special && (
                <CheckOutlinedIcon
                  color="success"
                  fontSize="small"
                  style={{ marginRight: "0.5rem" }}
                />
              )}
              Um caractere especial ($@!#*&)
            </ListItem>
            <ListItem>
              {letters && (
                <CheckOutlinedIcon
                  color="success"
                  fontSize="small"
                  style={{ marginRight: "0.5rem" }}
                />
              )}
              Uma letra maiúscula e minúscula
            </ListItem>
          </List>
        </FormHelperText>
      )}
    </>
  );
};
